import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PrizeFilterEntity } from '../../domain/entities/PrizeFilterEntity'

export class PrizeFilterModel extends PrizeFilterEntity {
  constructor(dataDto: PrizeFilterEntity) {
    super()
    mapEntityProperties<PrizeFilterEntity>(this, dataDto)
  }
}
